import * as groupActions from '../actions/Groups';

const initialState = {
  groups: [],
  list: [],
  offset: 0,
  limit: 10,
  totalCount: 7,
  detail: {
    groupId: 1,
    groupName: 'グループ１',
    zipCode: '819-0000',
    countryCode: 'JP',
    prefectures: '福岡県',
    city: '福岡市中央区',
    address: '今泉1-20-2',
    building: 'MENTビル4F',
    phone: '090-0000-0000',
    fax: '090-1111-1111',
    email: 'test@test.com',
    groupShops: [
      {
        groupShopId: 1,
        groupId: 1,
        groupName: 'グループ１',
        shopId: 1,
        shopName: '店舗A',
        status: 'APPROVAL'
      },
      {
        groupShopId: 2,
        groupId: 1,
        groupName: 'グループ１',
        shopId: 2,
        shopName: '店舗B',
        status: 'APPROVAL'
      },
      {
        groupShopId: 3,
        groupId: 1,
        groupName: 'グループ１',
        shopId: 3,
        shopName: '店舗C',
        status: 'APPROVAL'
      },
      {
        groupShopId: 4,
        groupId: 1,
        groupName: 'グループ１',
        shopId: 4,
        shopName: '店舗D',
        status: 'APPROVAL'
      },
      {
        groupShopId: 5,
        groupId: 1,
        groupName: 'グループ１',
        shopId: 5,
        shopName: '店舗E',
        status: 'APPROVAL'
      },
      {
        groupShopId: 6,
        groupId: 1,
        groupName: 'グループ１',
        shopId: 6,
        shopName: '店舗F',
        status: 'APPROVAL'
      }
    ],
    createdAt: '2019-01-01 12:00:00',
    updatedAt: '2019-01-01 12:00:00'
  },
  error: false,
  status: 200,
  error_message: ''
};

const groups = (state = initialState, action) => {
  switch (action.type) {
    case groupActions.GET_GROUPS_SUCCESS:
      return Object.assign({}, state, action.payload);
    case groupActions.GET_GROUPS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case groupActions.GET_GROUP_DETAIL_SUCCESS:
      return Object.assign({}, state, { detail: action.payload });
    case groupActions.GET_GROUP_DETAIL_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case groupActions.EDIT_GROUP_SUCCESS:
      return Object.assign({}, state, { edit: action.payload });
    case groupActions.EDIT_GROUP_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case groupActions.COUNT_GROUP_EMAIL_SUCCESS:
      return Object.assign({}, state, { groupEmails: action.payload });
    case groupActions.COUNT_GROUP_EMAIL_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default groups;
